import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/activityShifts`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityShifts/${id}`, options)
        .then(response => {
            let activityShift = jsona.deserialize(response.data);
            delete activityShift.links;
            return activityShift;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityShifts/${id}`, options)
        .then(response => {
            let activityShift = jsona.deserialize(response.data);
            delete activityShift.links;
            return activityShift;
        });
}

function add (activityShift) {
    const payload = jsona.serialize({
        stuff: activityShift,
        includeNames: ['shift','activityGuidance','schedules','exceptions']
    });
    // includeNames: ['shift','activity_guidance','schedules','exceptions']

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activityShifts`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (activityShift) {
    const payload = jsona.serialize({
        stuff: activityShift,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
        // ?include=activity,shift,vessel,workplace,guidance,exceptions
    return axios.patch(`${url}/activityShifts/${activityShift.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activityShifts/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

